import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import VueCookies from 'vue-cookies';
import { Spin } from 'view-design'

const router = new Router({
  mode: "history",
  routes: [

    {
      path: "/",
      name: "Login",
      component: resolve => require(["../views/login.vue"], resolve)
    },
    {
      path: "/MeetingRoomList",
      name: "MeetingRoomList",
      component: resolve => require(["../views/meeting_room_list.vue"], resolve)
    },
    {
      path: "/LiveMeetingRoomList",
      name: "LiveMeetingRoomList",
      component: resolve => require(["../views/live_meeting_room_list.vue"], resolve)
    },
    {
      path: "/HelpCenter",
      name: "HelpCenter",
      component: resolve => require(["../views/help_center.vue"], resolve)
    },
    {
      path: "/Notice",
      name: "Notice",
      component: resolve => require(["../views/notice.vue"], resolve)
    },
    {
      path: "/TagList",
      name: "TagList",
      component: resolve => require(["../views/tag_list.vue"], resolve)
    },
    {
      path: "/CompanyList",
      name: "CompanyList",
      component: resolve => require(["../views/company_list.vue"], resolve)
    },
    {
      path: "/UserList",
      name: "UserList",
      component: resolve => require(["../views/user_list.vue"], resolve)
    },
    {
      path: "/EventList",
      name: "EventList",
      component: resolve => require(["../views/event_list.vue"], resolve)
    },
    {
      path: "/Sport",
      name: "Sport",
      component: resolve => require(["../views/sport.vue"], resolve)
    },
    {
      path: "/sport_detail/:id",
      name: "sport_detail",
      component: resolve => require(["../views/sport_detail.vue"], resolve)
    },
    {
      path: "/Event/:event_id",
      name: "Event",
      component: resolve => require(["../views/event_detail.vue"], resolve)
    },
    {
      path: "/SensitiveWords",
      name: "SensitiveWords",
      component: resolve => require(["../views/sensitive_words.vue"], resolve)
    },
    {
      path: "/VideoManage",
      name: "VideoManage",
      component: resolve => require(["../views/video_manage.vue"], resolve)
    },
    {
      path: "/ChannelManage",
      name: "ChannelManage",
      component: resolve => require(["../views/channel_manage.vue"], resolve)
    },
    {
      path: "/AdminList",
      name: "AdminList",
      component: resolve => require(["../views/admin_list.vue"], resolve)
    },
    {
      path: "/ReportViewerList",
      name: "ReportViewerList",
      component: resolve => require(["../views/report_viewer_list.vue"], resolve)
    },
    {
      path: "/Report",
      name: "Report",
      component: resolve => require(["../views/report.vue"], resolve)
    },
    {
      path: "/Application",
      name: "Application",
      component: resolve => require(["../views/application.vue"], resolve)
    }
  ]
});

router.beforeEach((to, from, next) => {
  let session_key = VueCookies.get("kls_user_session");

  if (to.name != "Login" && (session_key == null || session_key == undefined)) {
    location.href = process.env.USER_PORTAL_URL
    return;
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js